import { SvgMoon, SvgSun } from "@itwin/itwinui-icons-react"
import { IconButton, Tooltip } from "@itwin/itwinui-react"
import { useAppDispatch, useAppSelector } from "store";
import { themeChanged } from "store/features";

export const ThemeChangerButton = () => {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.settings.theme);

  const onClick = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    dispatch(themeChanged(newTheme));
    localStorage.setItem("theme", newTheme);
  }

  return (
    <Tooltip content="Toggle display theme from dark to light" placement="bottom" delay={500}>
      <IconButton styleType="borderless" onClick={onClick}>
        {theme === "light" ? <SvgSun /> : <SvgMoon />}
      </IconButton>
    </Tooltip>
  )
}
